import { useCallback, useEffect, useRef, useState } from 'react';
import ManorShell from './ManorShell';
import ManorPuzzle from './ManorPuzzle';
import usePortrait from './usePortrait';
import { PopupMessage, RulesButton, RulesModal, useStageSubmit } from './StageChrome';
import scene from './scenes/stage3Scene';

const PUZZLE_IMAGE = '/manor/img/Mascot_mobo.png';
const PUZZLE_ASPECT = 300 / 423;
const RULES = [
  'Drag and drop the jigsaw pieces to complete the picture.',
  "Place the right puzzle pieces in the correct position while changing the pieces' color.",
];

// Stage 3 (stage3.php): click the character, solve the jigsaw, the portrait frame appears,
// a jump-scare flashes, then the message opens; closing it submits the stage (10 points).
// Landscape uses the SVG scene; portrait phones get the phone background with the same
// three pieces (character, empty frame, jump-scare) laid out over it.
export default function ManorStage3() {
  const submit = useStageSubmit(3);
  const portrait = usePortrait();
  const [phase, setPhase] = useState('scene'); // scene -> puzzle -> frame -> scare -> message
  const [showRules, setShowRules] = useState(false);
  const timers = useRef([]);

  useEffect(() => () => timers.current.forEach(clearTimeout), []);
  const later = (fn, ms) => timers.current.push(setTimeout(fn, ms));

  const startPuzzle = () => {
    if (phase === 'scene') setPhase('puzzle');
  };
  const onSceneClick = (e) => {
    if (e.target.closest?.('#Tatya')) startPuzzle();
  };

  const onFinished = useCallback(() => {
    later(() => {
      setPhase('frame');
      later(() => {
        setPhase('scare');
        later(() => setPhase('message'), 2500);
      }, 2500);
    }, 1800);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const frameShown = phase === 'frame' || phase === 'scare' || phase === 'message';

  return (
    <ManorShell bgMob="stage3/stage3-mob.jpg" stage={3} className={`manor-stage3 phase-${phase}`}>
      {portrait ? (
        <div className="manor-s3m">
          {frameShown && <img className="manor-s3m-frame" src="/manor/stage3/stage3-3.png" alt="" />}
          <button type="button" className="manor-img-btn manor-s3m-doll" onClick={startPuzzle} aria-label="Start puzzle">
            <img src="/manor/stage3/stage3-4.png" alt="" />
          </button>
          {phase === 'scare' && <img className="manor-s3m-scare" src="/manor/stage3/stage3-5.png" alt="" />}
        </div>
      ) : (
        <div className="manor-svgfile" onClick={onSceneClick} dangerouslySetInnerHTML={{ __html: scene }} />
      )}

      <img
        className={`manor-drop manor-title manor-stage3-title${phase === 'scene' ? '' : ' out'}`}
        style={{ top: '5%', width: '50%' }}
        src="/manor/img/stage3/Stage3Title.png"
        alt="Stage 3"
      />
      <div className="manor-toolbar">
        <RulesButton onClick={() => setShowRules(true)} />
      </div>

      {phase === 'puzzle' && (
        <div className="manor-puzzle-wrap">
          <ManorPuzzle image={PUZZLE_IMAGE} aspect={PUZZLE_ASPECT} onFinished={onFinished} />
        </div>
      )}
      {showRules && <RulesModal rules={RULES} onClose={() => setShowRules(false)} />}
      {phase === 'message' && (
        <PopupMessage src="/manor/img/stage3/Stage3popupmessage.png" alt="Stage 3 message" width="min(550px, 70vw)" onClose={() => submit(10)} />
      )}
    </ManorShell>
  );
}
